export default {
	'shared.all': 'Всі',
	'shared.minutes': 'хвилин',
	'shared.submit': 'Надіслати',
	'shared.closeDrawer': 'Закрити панель',
};
